import React from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Form,
  Input,
  InputGroupText,
  Button,
} from 'reactstrap';
import { CookbookMealListEdge, useTranslator } from '@front-activerse/common-components';

import { useAppContext } from '@front-activerse/common-components';

interface ICookbookFavMealsFilters {
  meals: CookbookMealListEdge[];
  active: string;
  setActive: (category: string) => void;
  search: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleReset: () => void;
  useSearchResult: boolean;
}

export const CookbookFavMealsFilters: React.FC<ICookbookFavMealsFilters> = ({
  meals,
  active,
  setActive,
  search,
  handleChange,
  handleSubmit,
  handleReset,
  useSearchResult,
}) => {
  const { t } = useTranslator();

  const {
    images: { searchIcon },
  } = useAppContext();

  const categoryArray: string[] = [];

  if (meals) {
    const sortedFavMeals = [...meals].sort((a, b) =>
      a.node.tags.mealTypeTags[0].id > b.node.tags.mealTypeTags[0].id
        ? 1
        : b.node.tags.mealTypeTags[0].id > a.node.tags.mealTypeTags[0].id
        ? -1
        : 0
    );

    sortedFavMeals.forEach((meal) => {
      if (
        !categoryArray.includes(meal.node.tags.mealTypeTags[0].name) &&
        meal.node.tags.mealTypeTags[0].name
      ) {
        categoryArray.push(meal.node.tags.mealTypeTags[0].name);
      }
    });
  }

  if (
    (categoryArray.length === 1 && active !== 'all') ||
    (!categoryArray.includes(active) && active !== 'all')
  ) {
    setActive('all');
  }

  return (
    <>
      <Row>
        <Col md={{ size: 8, offset: 2 }}>
          <div className="search-container">
            <Form onSubmit={handleSubmit}>
              <div className="input-group-with-addon start">
                <InputGroupText>
                  <img src={searchIcon} alt="search" />
                </InputGroupText>
                <Input
                  name="search"
                  type="search"
                  value={search}
                  onChange={handleChange}
                  placeholder={t('meal.search.inputPlaceholder')}
                />
                {useSearchResult && (
                  <Button color="link" size="sm" onClick={handleReset} className="ms-2">
                    {t('meal.search.cancelButton')}
                  </Button>
                )}
              </div>
            </Form>
          </div>
        </Col>
      </Row>

      <div className="sub-navigation">
        {categoryArray.length > 1 && (
          <Container>
            <Nav className="d-block">
              <NavItem>
                <NavLink active={active === 'all'} onClick={() => setActive('all')}>
                  {t('meal.favorites.filters.all')}
                </NavLink>
              </NavItem>
              {categoryArray.map((category) => (
                <NavItem key={category}>
                  <NavLink active={active === category} onClick={() => setActive(category)}>
                    {category}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Container>
        )}
      </div>
    </>
  );
};

export default CookbookFavMealsFilters;
